import { properties } from './properties';

// Shared root config (common across environments)
export const environment = {
    bannerConfiguration: properties.bannerConfiguration,
    production: false,
    myListDisclaimerContent: '/content/experience-fragments/www/disclaimers/my-list-disclaimer/my-list-disclaimer.content.html',
    SIGN_IN_URL: '/account/sign-in.html',
    RE_SIGN_IN_URL: '/account/re-sign-in.html',
    FORU_GUEST_BANNER_UNIT_XF: '/content/experience-fragments/xf/loyalty/b4u/foru_guest/{banner}/{banner}-forU/master.content.html',
    FORU_GUEST_BANNER: '/content/experience-fragments/xf/loyalty/b4u/foru_guest/{banner}/{banner}-forU/master.content.html',
    MY_LIST_GAM_TOP_XF: '/content/experience-fragments/xf/xf_spa_pages/my_list/gam-top/master.content.html',
    MY_LIST_GAM_SIDE_XF: '/content/experience-fragments/xf/xf_spa_pages/my_list/gam-sidebar/master.content.html',
    GALLERY_GAM_CAROSEL_XF: '/content/experience-fragments/xf/xf_spa_pages/coupon-deals/coupon-deals/top-carousel.content.html',
    GALLERY_GAM_SIDE_XF: '/content/experience-fragments/xf/xf_spa_pages/coupon-deals/coupon-deals/side-banner.content.html',
    GALLERY_GAM_BOTTOM_NON_ENDEMIC_XF: '/content/experience-fragments/xf/xf_spa_pages/coupon-deals/coupon-deals/coupons-deals.content.html',
    CLIENT_LIB_UNIFIED_HEADER: 'https://www-qa1.{banner}.com/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
    googleAdConfig: {
        displayAds: {
            bottomAd: true
        },
        adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
        gptScriptSrc: 'https://pagead2.googlesyndication.com/tag/js/gpt.js',
        endemicTopAd: {
            adUnitPath: "/22825627079/nonprod.{banner}/mylist/*/*.*/topb1",
            sizes: ["fluid"],
            targeting: [
                { txid: "ProductAlike" },
                { txpath: "1" },
                { store: "" },
            ]
        },
        endemicSideBanner: {
            adUnitPath: "/22825627079/nonprod.safeway/mylist/*/*.*/leftsideb1",
            sizes: ["fluid"],
            targeting: [
                { txid: "ProductAlike" },
                { txpath: "1" },
                { store: "" },
            ]
        }
    },
    local: {
        currentEnv: 'local',
        discoveryAPIPath: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
                'Accept': 'application/json, text/plain, */*',
                'Accept-Language': 'en-US,en;q=0.9',
                'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0',
                'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/qapub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '847f9f6ad22b4d86b3939e432bc87017'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    qa1: {
        currentEnv: 'qa1',
        discoveryAPIPath: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
            'Accept': 'application/json, text/plain, */*',
            'Accept-Language': 'en-US,en;q=0.9',
            'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
            'Content-Type': 'application/vnd.safeway.v1+json',
            'platform': 'web',
            'appversion': '1.0',
            'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/qapub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '847f9f6ad22b4d86b3939e432bc87017'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    qa2: {
        currentEnv: 'qa2',
        discoveryAPIPath: '/abs/acceptanceint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
            'Accept': 'application/json, text/plain, */*',
            'Accept-Language': 'en-US,en;q=0.9',
            'ocp-apim-subscription-key': 'b021c62ef0914b71961f8ec60e55d180',
            'Content-Type': 'application/vnd.safeway.v1+json',
            'platform': 'web',
            'appversion': '1.0',
            'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/acceptancepub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '5e3adce5db6b4221b4b1ef6492311a0c'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/acceptanceint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': 'b021c62ef0914b71961f8ec60e55d180',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    dev: {
        currentEnv: 'dev',
        discoveryAPIPath: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
            'Accept': 'application/json, text/plain, */*',
            'Accept-Language': 'en-US,en;q=0.9',
            'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
            'Content-Type': 'application/vnd.safeway.v1+json',
            'platform': 'web',
            'appversion': '1.0',
            'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/qapub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '0911d2f1158c411693295f54de3cfbee'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/devint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': '358df97a2fb54722b4c36a08cf74a76c',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    qa3: {
        currentEnv: 'perf',
        discoveryAPIPath: '/abs/perfint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
            'Accept': 'application/json, text/plain, */*',
            'Accept-Language': 'en-US,en;q=0.9',
            'ocp-apim-subscription-key': '9f9c5463cdaa444f88c902e8b3f37469',
            'Content-Type': 'application/vnd.safeway.v1+json',
            'platform': 'web',
            'appversion': '1.0',
            'Prefer': 'safe'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/perfint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': '9f9c5463cdaa444f88c902e8b3f37469',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    stage: {
        currentEnv: 'stage',
        discoveryAPIPath: '/abs/stgint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
            'Accept': 'application/json, text/plain, */*',
            'Accept-Language': 'en-US,en;q=0.9',
            'ocp-apim-subscription-key': 'A161f91a6dfa417c8365940f6d03f84e',
            'Content-Type': 'application/vnd.safeway.v1+json',
            'platform': 'web',
            'appversion': '1.0',
            'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/stgpub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': 'A161f91a6dfa417c8365940f6d03f84e'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/stgint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': 'A161f91a6dfa417c8365940f6d03f84e',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    },
    prod: {
        currentEnv: 'prod',
        production: true,
        discoveryAPIPath: '/abs/int/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
        discoveryAPIConfig: {
            httpHeaders: {
                'Accept': 'application/json, text/plain, */*',
                'Accept-Language': 'en-US,en;q=0.9',
                'ocp-apim-subscription-key': '5bf18a05fe7e43a09f1071ecd3b6e618',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0',
                'Prefer': 'safe'
            }
        },
        htoAllocationConfig: {
            path: '/abs/pub/dce/offerallocation/api/allocation/htoAllocation',
            headers: {
                'X-SWY_VERSION': '1.1',
                'X-SWY_API_KEY': 'emju',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': 'b7d21ba48b8745a092570523a5d03845'
            }
        },
        membershipBenefitsConfig: {
            apiPath: '/abs/int/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
            httpHeaders: {
                'ocp-apim-subscription-key': '5bf18a05fe7e43a09f1071ecd3b6e618',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'platform': 'web',
                'appversion': '1.0'
            }
        }
    }
};